export const SportSelectionStatus = {
	Pending: 1,
	Active: 2,
	Resulted: 3,
	Void: 4,
	Win: 5,
	Lost: 6
};
